const questions = {
        health: [
            "I'm too old for that now",
            "It's all downhill after 40/50/60",
            "Physical deterioration is expected after a certain age",
            "Getting tired easily is normal after a certain age",
            "It depends on my genes, if they are bad, there's nothing I can do",
            "After a certain age, metabolism slows down",
            "I don't have time to exercise",
            "Healthy food is too expensive (and therefore I cannot have a healthy diet)",
            "It's hard to lose weight after a certain age",
            "Getting sick is part of getting older",
            "I don't have the energy",
            "Stress is just part of modern life",
            "I am not disciplined enough to eat well/exercise",
            "Doctors know best—I seldom question them",
            "If the doctor says I need surgery, then I must do it",
            "If something's wrong with my health only medication can fix it",
            "Old age means everything becomes difficult"
        ],
        money: [
            "I'm not good with money",
            "Money doesn't grow on trees",
            "There are things that I want but cannot afford",
            "Rich people are greedy or corrupt",
            "I'll never be able to buy a house",
            "I am living paycheck to paycheck and I don't see that changing",
            "Money is the root of all evil",
            "I work hard but I'm still broke/not able to save",
            "I'll never get out of debt",
            "You need money to make money",
            "I'm just not meant to be wealthy",
            "Saving is pointless with my income and expenses",
            "Money causes more problems than it solves",
            "Making money depends on your circumstances and opportunities",
            "It's impossible in this timeline to make millions",
            "I'm stuck in this job",
            "It's too late to change careers",
            "I'm not willing to start from zero",
            "Work is supposed to be hard—that's why they call it work",
            "Playing it safe is the smart choice",
            "One must have a secure job",
            "I'm not creative enough to do my own thing",
            "The market is too saturated",
            "There's a lot of competition and so I won't do what I want",
            "I prefer a job that gives me benefits and security than start my own business",
            "Starting my own business now is too risky—I have bills to pay and children to raise"
        ],
        relationships: [
            "All the good ones are taken",
            "I'm too damaged for a healthy relationship",
            "I always attract the wrong person",
            "I need someone to make me happy",
            "Men/women are all the same",
            "I am not attractive enough",
            "It's too late to find love",
            "I'm afraid to break up—what if I can't find love again?",
            "Relationships take too much work",
            "I'm better off alone",
            "I don't deserve to be loved",
            "My past relationships define my future ones",
            "I'm too set in my ways to compromise",
            "Nobody can put up with me/I'm difficult to live with",
            "Love is for other people, not me",
            "I need to fix myself before I can be in a relationship",
            "Relationships are a headache",
            "I will lose my freedom if I get in a relationship",
            "Relationships take too much effort",
            "Men/women are not to be trusted",
            "I feel trapped in a marriage/relationship I do not want",
            "I have kids, I cannot end my marriage/relationship",
            "I will be judged and criticized if I end my marriage/relationship",
            "I would rather stay in a relationship I do not want than separate and get judged and criticized",
            "I am not interesting or attractive enough for someone to want to date me"
        ],
        self: [
            "I am lazy",
            "I'm shy",
            "I'm not creative",
            "I'm not talented enough",
            "You need luck to succeed and I'm just not lucky",
            "I don't think I'm handsome/pretty",
            "There are things I don't like about my body/face",
            "I lack confidence",
            "I don't believe I can make a lot of money",
            "I'm a slow learner",
            "I feel uncomfortable with change",
            "I know all there is to know",
            "There is no hope",
            "I have grown to the max",
            "I want many things but I can't have them",
            "I want many things but don't know how to get them",
            "I'm not smart enough",
            "I'm not the kind of person who succeeds",
            "I don't have what it takes to succeed",
            "I feel like I'm falling behind in life",
            "I'm a failure",
            "I'm too sensitive",
            "I'm not interesting enough",
            "I always mess things up",
            "I'm not as good as other people",
            "I'm a procrastinator",
            "I'm not disciplined enough",
            "I'm too emotional",
            "I'm not a risk taker",
            "I give up too easily",
            "I'm invisible to others",
            "I'm not strong enough to handle difficult things",
            "I don't like it/I don't feel comfortable when things go wrong",
            "I just cannot handle difficult situations",
            "I'm not courageous enough",
            "I'm a people pleaser",
            "I don't finish what I start",
            "I'm too shy to put myself out there",
            "I am not meant for great things",
            "I'm easily intimidated",
            "I'm not the type that takes initiative",
            "I blame others for where I am right now",
            "Time is running out and this stresses me (not enough time to do what I want)"
        ]
    };

    const interpretations = {
        health: {
            strongPositive: `You hold empowering beliefs about health and aging. This signal reinforces vitality, resilience, and wellbeing. Keep nurturing your trust in your body by listening to it, supporting it, and staying emotionally aligned. Strong Positive health signals tend to expand when paired with gratitude and low emotional resistance.`,
            leaningNegative: `Your mind knows the body is capable, but old programming still whispers doubt. You may catch yourself expecting decline or believing energy naturally weakens with age. Start shifting the signal by questioning inherited beliefs ("Is this truly my belief or something I absorbed?"). Small daily rituals of self-care can strengthen trust-based emotions.`,
            strongNegative: `You may interpret symptoms as signs of decline or believe your body is fragile or predetermined by genes. This signal creates stress, fear, and hypervigilance. Your first step is not physical—it is emotional. Replace "my body is failing" with "my body responds to my belief." The more trust you build, the stronger your health signal becomes.`
        },
        money: {
            strongPositive: `You trust that money and opportunities can flow to you. You see yourself as capable, resourceful, and worthy. This signal attracts growth, aligned work, and unexpected opportunities. Keep reinforcing your belief by focusing on ideas, creativity, and intention rather than fear.`,
            leaningNegative: `You may want more from life but still believe that limitations, scarcity, or obstacles have more power than your signal. You might fluctuate between motivation and discouragement. Focus on strengthening beliefs about your worth and potential. Purpose grows where trust grows.`,
            strongNegative: `You may feel stuck, unsupported, or fearful about finances and career. You might believe others succeed because they have advantages you don't. These beliefs weaken the signal and close the mind to new possibilities. Start with one simple shift: "My signal creates my outcomes, not my circumstances." Build from there.`
        },
        relationships: {
            strongPositive: `You trust love, connection, and compatibility. You believe healthy relationships are possible. This signal attracts emotional safety and aligned partners. Keep reinforcing self-respect and clear boundaries—they amplify this signal.`,
            leaningNegative: `You desire connection but still fear rejection, abandonment, or disappointment. You may have mixed beliefs about whether love is safe or attainable. Start shifting your signal through vulnerability with yourself first, then with others.`,
            strongNegative: `You may hold deep fear-based beliefs about relationships—that love hurts, partners cannot be trusted, or that you are safer alone. These beliefs can make intimacy feel threatening. Your first step is to rebuild trust from within: "I am safe loving and being loved." Emotional self-safety rewires this signal.`
        },
        self: {
            strongPositive: `You see yourself as capable, worthy, and evolving. This creates a powerful, stable broadcast that influences every area of life. Continue nurturing self-trust by honouring your desires, taking consistent aligned action, and speaking to yourself with respect.`,
            leaningNegative: `You have moments of confidence followed by self-criticism or doubt. You want to trust yourself more but old narratives interfere. Start practicing micro-acts of self-trust—small decisions where you follow your inner signal rather than fear. Consistency builds strength.`,
            strongNegative: `You may often speak to yourself critically, feel unworthy, or fear that you are "not enough." These beliefs create the weakest signal but also the most potential for transformation. Every belief here can be rewritten. Begin with one new thought: "My signal is mine to shape." The more trust you feel toward yourself, the more every other signal in your life transforms.`
        }
    };

    /* ---- Build question HTML ---- */
    function createQuestions() {
        const form = document.getElementById('signalForm');
        const categories = [
            { key: 'health',        element: form.querySelector('.category:nth-of-type(1)') },
            { key: 'money',         element: form.querySelector('.category:nth-of-type(2)') },
            { key: 'relationships', element: form.querySelector('.category:nth-of-type(3)') },
            { key: 'self',          element: form.querySelector('.category:nth-of-type(4)') }
        ];

        categories.forEach(cat => {
            questions[cat.key].forEach((question, index) => {
                const div = document.createElement('div');
                div.className = 'question';
                div.innerHTML = `
                    <div class="question-text">${index + 1}. ${question}</div>
                    <div class="rating-scale">
                        ${[1, 2, 3, 4, 5].map(r => `
                            <div class="rating-option">
                                <input type="radio" id="${cat.key}_${index}_${r}"
                                       name="${cat.key}_${index}" value="${r}" required>
                                <label for="${cat.key}_${index}_${r}">${r}</label>
                            </div>
                        `).join('')}
                    </div>
                    <div class="scale-legend">
                        <span>1 = Not true at all</span>
                        <span>5 = Very true</span>
                    </div>
                `;
                cat.element.appendChild(div);
            });
        });
    }

    /* ---- Progress ---- */
    function updateProgress() {
        const total    = 111;
        const answered = document.querySelectorAll('input[type="radio"]:checked').length;
        const pct      = Math.round((answered / total) * 100);
        document.getElementById('progress').textContent =
            `Progress: ${answered} of ${total} answered (${pct}%)`;
        const fill = document.getElementById('progressFill');
        if (fill) fill.style.width = pct + '%';
    }

    /* ---- Scoring ---- */
    function calculateScore(category) {
        let total = 0;
        const n = questions[category].length;
        for (let i = 0; i < n; i++) {
            const sel = document.querySelector(`input[name="${category}_${i}"]:checked`);
            if (sel) total += parseInt(sel.value);
        }
        return total;
    }

    function getSignalType(category, score) {
        const ranges = {
            health:        { strongPositive: [17, 39],   leaningNegative: [40, 62],   strongNegative: [63, 85]  },
            money:         { strongPositive: [26, 58],   leaningNegative: [59, 94],   strongNegative: [95, 130] },
            relationships: { strongPositive: [25, 60],   leaningNegative: [61, 90],   strongNegative: [91, 125] },
            self:          { strongPositive: [43, 100],  leaningNegative: [101, 160], strongNegative: [161, 215] }
        };
        const r = ranges[category];
        if (score >= r.strongPositive[0]  && score <= r.strongPositive[1])  return 'strongPositive';
        if (score >= r.leaningNegative[0] && score <= r.leaningNegative[1]) return 'leaningNegative';
        return 'strongNegative';
    }

    /* ---- Display results ---- */
    function displayResults(scores) {
        const catNames = {
            health:        'Health / Wellbeing / Longevity',
            money:         'Money / Career / Life Purpose',
            relationships: 'Intimate Relationships',
            self:          'Relationship with Myself'
        };
        const typeNames = {
            strongPositive:  'Strong Positive',
            leaningNegative: 'Leaning Negative',
            strongNegative:  'Strong Negative'
        };

        // Summary
        let summaryHTML = '';
        Object.keys(scores).forEach(cat => {
            summaryHTML += `<div class="summary-item">● ${catNames[cat]}: <strong>${typeNames[scores[cat].type]}</strong></div>`;
        });
        document.getElementById('summaryList').innerHTML = summaryHTML;

        // Detailed cards
        let detailHTML = '';
        Object.keys(scores).forEach(cat => {
            const type      = scores[cat].type;
            const typeClass = type.replace(/([A-Z])/g, '-$1').toLowerCase();
            detailHTML += `
                <div class="result-category">
                    <h3>${catNames[cat]} Signal</h3>
                    <div class="signal-type ${typeClass}">${typeNames[type]}</div>
                    <div class="interpretation">${interpretations[cat][type]}</div>
                </div>
            `;
        });
        document.getElementById('detailedResults').innerHTML = detailHTML;

        // Switch view
        document.getElementById('assessment').style.display = 'none';
        document.getElementById('results').classList.add('show');
        document.getElementById('headerLabel').textContent = 'Your Signal Results';
        window.scrollTo(0, 0);
    }

    /* ---- Form submit ---- */
    document.getElementById('signalForm').addEventListener('submit', function(e) {
        e.preventDefault();
        const scores = {
            health:        { score: calculateScore('health'),        type: null },
            money:         { score: calculateScore('money'),         type: null },
            relationships: { score: calculateScore('relationships'), type: null },
            self:          { score: calculateScore('self'),          type: null }
        };
        Object.keys(scores).forEach(cat => {
            scores[cat].type = getSignalType(cat, scores[cat].score);
        });
        const email = document.getElementById('userEmail').value;
        if (email) { console.log('Email collected:', email); }
        displayResults(scores);
    });

    /* ---- Live progress ---- */
    document.addEventListener('change', function(e) {
        if (e.target.type === 'radio') updateProgress();
    });

    /* ---- Init ---- */
    createQuestions();
    updateProgress();